export default {
    'me.title': '會員資料',
    'me.line_id': 'LINE ID',
    'me.member_card_number': '會員卡號',
    'me.education_background': '學歷',
    'me.habit': '興趣喜好',
    'me.register_full': '註冊成為正式會員',
    'me.modify': '修改會員資料',
} as Record<string, string>;
